export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "en",
    "resource": {
      "all_program": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["All Programs"])}
    }
  })
}
